import React, { useState,useEffect } from 'react'
import { useTransition, useSpring, animated } from '@react-spring/web'
import { ScaleLoader } from 'react-spinners'
import { clamp } from 'lodash'


import { useApp } from 'store/AppStore'

import ProductSelector from './ProductSelector'
import ProductSlider from './ProductSlider'
import FeatureBox from './FeatureBox'
import Modal from './Modal'
import PhotoGallery from './PhotoGallery'
import chart1 from 'assets/chart/chart_1.jpg'
import chart1Thumb from 'assets/chart/chart_1_thumb_grey.png'
import chart2 from 'assets/chart/chart_2.jpg'
import chart2Thumb from 'assets/chart/chart_2_thumb_grey.png'
import chart3 from 'assets/chart/chart_3.jpg'
import chart3Thumb from 'assets/chart/chart_3_thumb_grey.png'

import { Footer, Header, Root,PhotoGalleryAnimated } from './Timeline.styled.js'

import "./Arrows.css";
import ReactGA from "react-ga4";


ReactGA.send({ hitType: "pageview", page: "/Landing", title: "Landing" });



//import DidYouKnow from './DidYouKnow'
 
const Timeline = ({ entering }) => {
  const { isReady , selectedProductIndex, products, setSelectedProduct} = useApp()
  const [modalVariant, setModalVariant] = useState()
  const [footerShow, setfooterShow] = useState(true)
  const [keyboardNav, setKeyboardNav] = useState(0)



  const images = [
    {
      thumb: chart1Thumb,
      full: chart1,
      title: "Less Toxicants",
    },
    {
      thumb: chart2Thumb,
      full: chart2,
      title: "Risk Reduction",
    },
    {
      thumb: chart3Thumb,
      full: chart3,
      title: "Temperature & Toxicants",
    },
  ];

  const modalTransition = useTransition(modalVariant, {
    from: { y: '100%', opacity: 0 },
    enter: { y: '0%', opacity: 1 },
    leave: { y: '0%', opacity: 0 },
  })

  const start = isReady && entering === 100

  const { headerY, footerY, sliderX, dykScale,opacityFooter } = useSpring({
    
    from: { headerY: '-100%', footerY: '100%', sliderX: '100%', dykScale: 0 ,opacityFooter :1},
    to: [
      { headerY: start ? '0%' : '-100%' },
      { footerY: start ? (footerShow ? '0%':'100%') : '100%' },
      { sliderX: start ? '0%' : '100%' },
      { dykScale: start ? 1 : 0 },
      { opacityFooter: footerShow ? 1 : 0 },
      
      
    ],
    delay: (key) => {
      if (key === 'dykScale') {
        return 5000
      }
      return 0
    },
  })


  useEffect(() => {
    
    //console.log("execute :",selectedProductIndex)
    if (selectedProductIndex===8){
      setfooterShow(false)
    }else{
      setfooterShow(true)
    }
    return () => console.log("close :",selectedProductIndex)
  }, [selectedProductIndex])

  const loaderTransition = useTransition(!start, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    delay: start ? 0 : 0,
  })


  const galeryTransition = useTransition(!footerShow, {
    from: { opacity: 0 },
    enter: {  opacity: 0 },
    leave: {  opacity: 0 },
    delay: footerShow ? 0 : 0,
  })


  useEffect(() => {
    if (keyboardNav !== 0) {
      const nextSlideIndex = clamp(selectedProductIndex + keyboardNav, 0, products.length - 1)
      setKeyboardNav(0)
      setSelectedProduct(nextSlideIndex)
    }
  }, [keyboardNav, setKeyboardNav, selectedProductIndex, products.length, setSelectedProduct])

  const goBack = () => setKeyboardNav(-1)
  const goForward = () => setKeyboardNav(1)


  return (
    <Root blur={modalVariant !== undefined}>
      {loaderTransition(
        (styles, item) =>
          item && (
            <animated.div className="Loader" style={styles}>
              <ScaleLoader color="currentColor"></ScaleLoader>
            </animated.div>
          )
      )}
      
      <div className="Inner">
        <Header style={{ y: headerY }}>
          <FeatureBox></FeatureBox>
          
        </Header>
        

        <ProductSlider style={{ x: sliderX }}></ProductSlider>
        
        {galeryTransition(
        (styles, item) =>
          item && (
        <PhotoGalleryAnimated style={{display: "none"}}>
        <PhotoGallery images={images}  />
        </PhotoGalleryAnimated>
          )
        )}

        <Footer style={{ y: footerY ,opacity:opacityFooter}}>
          <center className='LeftArrow'>
        <h1 onClick={() => goBack()} style={{fontWeight: "500", color: "rgb(13, 82, 116)", backgroundColor: "white", boxShadow: "13px 3px 15px 11px #FFFFFF", zIndex: 9999999, pointerEvents: "all"}}>&lt;</h1>
        </center>
          <ProductSelector
            handleModalVariant={(variant) => setModalVariant(variant)}
          ></ProductSelector>
          <center className='RightArrow'>
          <h1 onClick={() => goForward()} style={{fontWeight: "500", color: "rgb(13, 82, 116)", backgroundColor: "white", boxShadow: "-13px 3px 15px 11px #FFFFFF", zIndex: 9999999, pointerEvents: "all"}}>&gt;</h1>
          </center>
        </Footer>
      </div>
      
      {modalTransition(
        (styles, item) =>
          item !== undefined && (
            <Modal variant={item} closeModal={() => setModalVariant()} style={styles}></Modal>
          )
      )}
    </Root>
  )
}



/* <DidYouKnow style={{ scale: dykScale }}></DidYouKnow>
      {modalTransition(
        (styles, item) =>
          item !== undefined && (
            <Modal variant={item} closeModal={() => setModalVariant()} style={styles}></Modal>
          )*/
export default Timeline
